var _g, _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFullWidth(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 295,
    height: 269,
    viewBox: "0 0 295 269",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14008_88984)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_14008_88984)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 295,
    height: 269,
    rx: 8,
    fill: "#EEF0FC"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0 8C0 3.58172 3.58172 0 8 0H287C291.418 0 295 3.58172 295 8V44H0V8Z",
    fill: "#DADCE8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 59,
    width: 167,
    height: 8,
    rx: 1,
    fill: "#DADCE8"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 16,
    y: 73,
    width: 220,
    height: 8,
    rx: 1,
    fill: "#DADCE8"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 16,
    y: 247,
    width: 220,
    height: 8,
    rx: 1,
    fill: "#DADCE8"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 16,
    y: 233,
    width: 263,
    height: 8,
    rx: 1,
    fill: "#DADCE8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.5,
    y: 97.5,
    width: 262,
    height: 118,
    rx: 3.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.5,
    y: 97.5,
    width: 262,
    height: 118,
    rx: 3.5,
    fill: "#2356F6",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.5,
    y: 97.5,
    width: 262,
    height: 118,
    rx: 3.5,
    stroke: "#2356F6",
    strokeLinecap: "round",
    strokeDasharray: "2 5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M108.829 161.128C110.173 161.128 111.261 160.44 111.581 159.384V161H114.077V156.472C114.077 155.64 113.469 154.712 112.333 154.712H109.181V156.792H111.181C111.341 156.792 111.437 156.904 111.437 157.08C111.437 157.864 110.189 158.856 108.989 158.856C107.309 158.856 105.949 157.464 105.949 155.4C105.949 153.336 107.309 152.104 109.037 152.104C110.365 152.104 111.181 152.792 111.325 153.88H114.109C114.013 151.384 111.981 149.672 109.069 149.672C106.029 149.672 103.261 151.576 103.261 155.4C103.261 159.224 105.933 161.128 108.829 161.128ZM115.533 161H118.173V152.936H115.533V161ZM115.485 151.944H118.237V149.352H115.485V151.944ZM121.883 161H124.219L127.163 152.936H124.475L123.051 157.624L121.611 152.936H118.939L121.883 161ZM127.923 161H130.563V152.936H127.923V161ZM127.875 151.944H130.627V149.352H127.875V151.944ZM132.001 161H134.641V156.552C134.641 155.752 135.201 155.144 136.001 155.144C136.801 155.144 137.361 155.752 137.361 156.552V161H140.001V155.928C140.001 154.136 138.817 152.808 137.009 152.808C135.953 152.808 135.105 153.24 134.641 153.864V152.936H132.001V161ZM144.959 161.128C145.791 161.128 146.543 160.84 146.975 160.312V161.208C146.975 161.816 146.591 162.248 146.063 162.248H142.351V164.264H146.543C148.399 164.264 149.599 163.192 149.599 161.528V152.936H146.959V153.576C146.527 153.112 145.855 152.808 144.911 152.808C142.639 152.808 141.183 154.392 141.183 156.968C141.183 159.544 142.639 161.128 144.959 161.128ZM143.759 156.968C143.759 155.8 144.415 155.048 145.423 155.048C146.447 155.048 147.103 155.8 147.103 156.968C147.103 158.136 146.447 158.888 145.423 158.888C144.415 158.888 143.759 158.136 143.759 156.968ZM154.648 161H157.496V156.648H161.464V154.216H157.496V152.232H162.536V149.8H154.648V161ZM166.843 161.128C169.355 161.128 171.163 159.352 171.163 156.968C171.163 154.584 169.355 152.808 166.843 152.808C164.331 152.808 162.523 154.584 162.523 156.968C162.523 159.352 164.331 161.128 166.843 161.128ZM165.163 156.968C165.163 155.816 165.835 155.048 166.843 155.048C167.851 155.048 168.523 155.816 168.523 156.968C168.523 158.12 167.851 158.888 166.843 158.888C165.835 158.888 165.163 158.12 165.163 156.968ZM176.236 155.112H177.644V152.936H176.796C175.9 152.936 175.308 153.192 174.844 154.152V152.936H172.204V161H174.844V156.92C174.844 155.784 175.356 155.112 176.236 155.112ZM178.579 161H181.219V156.488C181.219 155.592 181.715 155.016 182.467 155.016C183.219 155.016 183.715 155.592 183.715 156.488V161H186.355V156.488C186.355 155.592 186.851 155.016 187.603 155.016C188.355 155.016 188.851 155.592 188.851 156.488V161H191.491V155.64C191.491 154.152 190.323 152.808 188.563 152.808C187.235 152.808 186.259 153.464 185.827 154.168C185.395 153.288 184.675 152.808 183.443 152.808C182.419 152.808 181.699 153.256 181.219 153.896V152.936H178.579V161Z",
    fill: "#2356F6"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 294,
    height: 268,
    rx: 7.5,
    stroke: "#DADCE8"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_14008_88984",
    x: -34,
    y: -30,
    width: 363,
    height: 337,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 17
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_14008_88984"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_14008_88984",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14008_88984"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 295,
    height: 269,
    rx: 8,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullWidth);
export default __webpack_public_path__ + "static/media/FullWidth.f0026e6c3830aa83bba5881e900a04ab.svg";
export { ForwardRef as ReactComponent };